{
  "GENERAL": {
    "CLOSE": "Đóng",
    "SHOWING_RESULTS": "Showing {firstIndex}-{lastIndex} of {totalCount} items",
    "PHONE_INPUT": {
      "PLACEHOLDER": "Tìm kiếm",
      "EMPTY_STATE": "Không tìm thấy kết quả"
    }
  },
  "TAG_INPUT": {
    "MIN_TAGS_REQUIRED": "Cần ít nhất {count}"
  }
}
